import { render, staticRenderFns } from "./TeamMemberDashboard.vue?vue&type=template&id=665abdb2"
import script from "./TeamMemberDashboard.vue?vue&type=script&lang=ts"
export * from "./TeamMemberDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports